{
  "schemaVersion": 1,
  "id": "lobby-date",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "units": "stage pixels",
  "sourceRoot": "repository root",
  "elementSizing": "left/top/width only; h = w * sourceH/sourceW; preserve aspect ratio; no 3-slice or stretch in this layout",
  "textCoordinates": "y is capital H top; baseline y+cap. maxW is hard ink-width limit. Never stretch glyphs. Ellipsis for player names.",
  "elements": [
    {
      "id": "background",
      "piece": "art/src/lobby-backgrounds-2026-09-22/date.png",
      "x": 0,
      "y": 0,
      "w": 941,
      "tint": "none"
    },
    {
      "id": "logo",
      "piece": "apps/client/public/art/room-logos/lobby-date.png",
      "x": 267,
      "y": 8,
      "w": 440,
      "tint": "none"
    },
    {
      "id": "back.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "tint": "none",
      "mirrorX": false
    },
    {
      "id": "back.icon",
      "piece": "apps/client/public/art/ui-head/icon-back@2x.png",
      "x": 16,
      "y": 9,
      "w": 120,
      "tint": "none"
    },
    {
      "id": "sound.button",
      "piece": "apps/client/public/art/ui-head/bg@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "tint": "none",
      "mirrorX": true
    },
    {
      "id": "sound.icon",
      "piece": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "x": 812,
      "y": 9,
      "w": 120,
      "tint": "none"
    },
    {
      "id": "sticker.ul",
      "piece": "sticker.ul.png",
      "x": 68,
      "y": 138,
      "w": 164,
      "tint": "none"
    },
    {
      "id": "sticker.ur",
      "piece": "sticker.ur.png",
      "x": 742,
      "y": 148,
      "w": 198,
      "tint": "none"
    },
    {
      "id": "sticker.l",
      "piece": "sticker.l.png",
      "x": 6,
      "y": 788,
      "w": 116,
      "tint": "none"
    },
    {
      "id": "sticker.r",
      "piece": "sticker.r.png",
      "x": 822,
      "y": 808,
      "w": 118,
      "tint": "none"
    },
    {
      "id": "seat1.avatar",
      "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
      "x": 116.5,
      "y": 396,
      "w": 290,
      "tint": "none",
      "clip": "circle",
      "opacity": 1,
      "binding": {
        "kind": "current-player-avatar-expression",
        "seat": 1
      }
    },
    {
      "id": "seat1.ring",
      "piece": "host.ring.large.png",
      "x": 70.5,
      "y": 334,
      "w": 382,
      "tint": "none"
    },
    {
      "id": "seat1.pill",
      "piece": "pill.large.png",
      "x": 70.5,
      "y": 714,
      "w": 382,
      "tint": "cyan"
    },
    {
      "id": "seat2.ring",
      "piece": "open.ring.large.png",
      "x": 488.5,
      "y": 383.474,
      "w": 382,
      "tint": "cyan"
    },
    {
      "id": "seat2.pill",
      "piece": "pill.large.png",
      "x": 488.5,
      "y": 714,
      "w": 382,
      "tint": "cyan"
    },
    {
      "id": "heart",
      "piece": "heart.png",
      "x": 446.5,
      "y": 515,
      "w": 48,
      "tint": "none"
    },
    {
      "id": "codebox.plate",
      "piece": "gather.plate.png",
      "x": 48.5,
      "y": 896,
      "w": 844,
      "tint": "cyan"
    },
    {
      "id": "copy.button",
      "piece": "copy.button.png",
      "x": 646.5,
      "y": 952,
      "w": 222,
      "tint": "cyan"
    },
    {
      "id": "copy.icon",
      "piece": "icon.link.png",
      "x": 672.5,
      "y": 989.583,
      "w": 42,
      "tint": "cyan"
    },
    {
      "id": "cta.plate",
      "piece": "cta.plate.png",
      "x": 48.5,
      "y": 1286,
      "w": 844,
      "tint": "none",
      "disabled": true,
      "brightness": 0.58,
      "opacity": 0.95
    },
    {
      "id": "howto.row",
      "piece": "howto.row.png",
      "x": 130.5,
      "y": 1142,
      "w": 680,
      "tint": "cyan"
    },
    {
      "id": "howto.chevron",
      "piece": "icon.chevron.png",
      "x": 734.5,
      "y": 1186.284,
      "w": 24,
      "tint": "none"
    },
    {
      "id": "invite.button",
      "piece": "small.button.png",
      "x": 48.5,
      "y": 1468,
      "w": 406,
      "tint": "cyan"
    },
    {
      "id": "invite.icon",
      "piece": "icon.people.png",
      "x": 105.5,
      "y": 1495,
      "w": 60,
      "tint": "none"
    },
    {
      "id": "edit.button",
      "piece": "small.button.png",
      "x": 486.5,
      "y": 1468,
      "w": 406,
      "tint": "cyan"
    },
    {
      "id": "edit.icon",
      "piece": "icon.pencil.png",
      "x": 543.5,
      "y": 1495,
      "w": 60,
      "tint": "none"
    }
  ],
  "texts": [
    {
      "id": "seat1.name",
      "text": "YOU",
      "x": 137.5,
      "y": 760,
      "w": 176,
      "cap": 28,
      "align": "center",
      "role": "name",
      "maxW": 176,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffffff",
      "fit": "ellipsis",
      "maxChars": 8,
      "binding": {
        "kind": "player-name",
        "seat": 1,
        "selfLabel": "YOU",
        "fallback": "Player",
        "maxGraphemesIncludingEllipsis": 8
      }
    },
    {
      "id": "seat1.status",
      "text": "HOST",
      "x": 329.5,
      "y": 764,
      "w": 56,
      "cap": 20,
      "align": "center",
      "role": "status",
      "maxW": 56,
      "font": "Barlow Condensed",
      "weight": 700,
      "color": "#ffd84a"
    },
    {
      "id": "seat2.name",
      "text": "Open Slot",
      "x": 567.5,
      "y": 758.5,
      "w": 224,
      "cap": 28,
      "align": "center",
      "role": "name",
      "maxW": 224,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffffff",
      "binding": {
        "kind": "literal",
        "text": "Open Slot"
      }
    },
    {
      "id": "code.heading",
      "text": "YOUR ROOM CODE",
      "x": 230.5,
      "y": 932,
      "w": 480,
      "cap": 21,
      "align": "center",
      "role": "heading",
      "maxW": 480,
      "font": "Nunito",
      "weight": 600,
      "color": "#d9e6ff",
      "tracking": 3
    },
    {
      "id": "code.value",
      "text": "89SVJJ",
      "x": 139.5,
      "y": 984,
      "w": 432,
      "cap": 48,
      "align": "center",
      "role": "value",
      "maxW": 432,
      "font": "Nunito",
      "weight": 900,
      "color": "#ff4fa8"
    },
    {
      "id": "code.url",
      "text": "play.saynoway.com/r/89SVJJ",
      "x": 139.5,
      "y": 1055,
      "w": 432,
      "cap": 20,
      "align": "center",
      "role": "sub",
      "maxW": 432,
      "font": "Nunito",
      "weight": 500,
      "color": "#ffffff",
      "overflow": "ellipsis-middle-for-unusually-long-host; copy still copies full URL"
    },
    {
      "id": "copy.label",
      "text": "COPY",
      "x": 741.5,
      "y": 999.583,
      "w": 88,
      "cap": 22,
      "align": "center",
      "role": "button",
      "maxW": 88,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffffff"
    },
    {
      "id": "cta.label",
      "text": "START DATE",
      "x": 231.5,
      "y": 1345.247,
      "w": 478,
      "cap": 40,
      "align": "center",
      "role": "cta",
      "maxW": 478,
      "font": "Nunito",
      "weight": 400,
      "color": "#17120a"
    },
    {
      "id": "howto.title",
      "text": "HOW TO PLAY",
      "x": 272.5,
      "y": 1189.284,
      "w": 340,
      "cap": 26,
      "align": "center",
      "role": "howto",
      "maxW": 340,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffd84a"
    },
    {
      "id": "invite.label",
      "text": "INVITE",
      "x": 211,
      "y": 1513,
      "w": 154,
      "cap": 24,
      "align": "center",
      "role": "button",
      "maxW": 154,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffffff"
    },
    {
      "id": "edit.label",
      "text": "EDIT",
      "x": 649,
      "y": 1513,
      "w": 154,
      "cap": 24,
      "align": "center",
      "role": "button",
      "maxW": 154,
      "font": "Nunito",
      "weight": 800,
      "color": "#ffffff"
    },
    {
      "id": "timer",
      "text": "Invites open for 14:53",
      "x": 170.5,
      "y": 1606,
      "w": 600,
      "cap": 28,
      "align": "center",
      "role": "footer",
      "maxW": 600,
      "font": "Nunito",
      "weight": 500,
      "color": "#ffffff"
    }
  ],
  "hitTargets": [
    {
      "id": "back",
      "x": 16,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "back"
    },
    {
      "id": "sound",
      "x": 812,
      "y": 9,
      "w": 120,
      "h": 120,
      "action": "toggle-sound"
    },
    {
      "id": "seat1",
      "x": 70.5,
      "y": 334,
      "w": 382,
      "h": 504,
      "action": "existing-seat-action",
      "note": "Avatar/ring and pill share one touch target. Only interactive where current lobby permissions allow; the hit region adds no painted art."
    },
    {
      "id": "seat2",
      "x": 488.5,
      "y": 334,
      "w": 382,
      "h": 504,
      "action": "existing-seat-action",
      "note": "Avatar/ring and pill share one touch target. Only interactive where current lobby permissions allow; the hit region adds no painted art."
    },
    {
      "id": "copy",
      "x": 646.5,
      "y": 952,
      "w": 222,
      "h": 117.167,
      "action": "copy-room-link"
    },
    {
      "id": "cta",
      "x": 48.5,
      "y": 1286,
      "w": 844,
      "h": 158.493,
      "action": "existing-primary-lobby-action",
      "disabled": true
    },
    {
      "id": "howto",
      "x": 130.5,
      "y": 1142,
      "w": 680,
      "h": 120.567,
      "action": "open-howto"
    },
    {
      "id": "invite",
      "x": 48.5,
      "y": 1467,
      "w": 406,
      "h": 116,
      "action": "invite"
    },
    {
      "id": "edit",
      "x": 486.5,
      "y": 1467,
      "w": 406,
      "h": 116,
      "action": "edit-room"
    }
  ],
  "seatVariants": {
    "1": {
      "open": {
        "elements": [
          {
            "id": "seat1.ring",
            "piece": "open.ring.large.png",
            "x": 70.5,
            "y": 383.474,
            "w": 382,
            "tint": "cyan"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "Open Slot",
            "x": 149.5,
            "y": 758.5,
            "w": 224,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 224,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "binding": {
              "kind": "literal",
              "text": "Open Slot"
            }
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      },
      "occupied": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
            "x": 127.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 1
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 79.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "x": 149.5,
            "y": 760.5,
            "w": 224,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 224,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      },
      "host": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
            "x": 116.5,
            "y": 396,
            "w": 290,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 1
            }
          },
          {
            "id": "seat1.ring",
            "piece": "host.ring.large.png",
            "x": 70.5,
            "y": 334,
            "w": 382,
            "tint": "none"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "x": 137.5,
            "y": 760,
            "w": 176,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 176,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat1.status",
            "text": "HOST",
            "x": 329.5,
            "y": 764,
            "w": 56,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 56,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#ffd84a"
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      },
      "ready": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
            "x": 127.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 1
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 79.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "x": 137.5,
            "y": 760,
            "w": 164,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 164,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat1.status",
            "text": "READY",
            "x": 317.5,
            "y": 764,
            "w": 68,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 68,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#4ff08a"
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      },
      "offline": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
            "x": 127.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 0.45,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 1
            }
          },
          {
            "id": "seat1.ring",
            "piece": "seat.ring.png",
            "x": 79.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "x": 137.5,
            "y": 760,
            "w": 148,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 148,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat1.status",
            "text": "OFFLINE",
            "x": 301.5,
            "y": 764,
            "w": 84,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 84,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#a9bbea"
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat1.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
            "x": 116.5,
            "y": 396,
            "w": 290,
            "tint": "none",
            "clip": "circle",
            "opacity": 0.45,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 1
            }
          },
          {
            "id": "seat1.ring",
            "piece": "host.ring.large.png",
            "x": 70.5,
            "y": 334,
            "w": 382,
            "tint": "none"
          },
          {
            "id": "seat1.pill",
            "piece": "pill.large.png",
            "x": 70.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat1.name",
            "text": "YOU",
            "x": 137.5,
            "y": 760,
            "w": 148,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 148,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 1,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat1.status",
            "text": "OFFLINE",
            "x": 301.5,
            "y": 764,
            "w": 84,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 84,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#a9bbea"
          }
        ],
        "removeIds": [
          "seat1.avatar",
          "seat1.status"
        ]
      }
    },
    "2": {
      "open": {
        "elements": [
          {
            "id": "seat2.ring",
            "piece": "open.ring.large.png",
            "x": 488.5,
            "y": 383.474,
            "w": 382,
            "tint": "cyan"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Open Slot",
            "x": 567.5,
            "y": 758.5,
            "w": 224,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 224,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "binding": {
              "kind": "literal",
              "text": "Open Slot"
            }
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      },
      "occupied": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
            "x": 545.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 2
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 497.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Bob",
            "x": 567.5,
            "y": 760.5,
            "w": 224,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 224,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      },
      "host": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
            "x": 534.5,
            "y": 396,
            "w": 290,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 2
            }
          },
          {
            "id": "seat2.ring",
            "piece": "host.ring.large.png",
            "x": 488.5,
            "y": 334,
            "w": 382,
            "tint": "none"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Bob",
            "x": 555.5,
            "y": 760,
            "w": 176,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 176,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat2.status",
            "text": "HOST",
            "x": 747.5,
            "y": 764,
            "w": 56,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 56,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#ffd84a"
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      },
      "ready": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
            "x": 545.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 1,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 2
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 497.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Bob",
            "x": 555.5,
            "y": 760,
            "w": 164,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 164,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat2.status",
            "text": "READY",
            "x": 735.5,
            "y": 764,
            "w": 68,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 68,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#4ff08a"
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      },
      "offline": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
            "x": 545.5,
            "y": 407,
            "w": 268,
            "tint": "none",
            "clip": "circle",
            "opacity": 0.45,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 2
            }
          },
          {
            "id": "seat2.ring",
            "piece": "seat.ring.png",
            "x": 497.5,
            "y": 387,
            "w": 364,
            "tint": "cyan"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Bob",
            "x": 555.5,
            "y": 760,
            "w": 148,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 148,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat2.status",
            "text": "OFFLINE",
            "x": 719.5,
            "y": 764,
            "w": 84,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 84,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#a9bbea"
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      },
      "host_offline": {
        "elements": [
          {
            "id": "seat2.avatar",
            "piece": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
            "x": 534.5,
            "y": 396,
            "w": 290,
            "tint": "none",
            "clip": "circle",
            "opacity": 0.45,
            "binding": {
              "kind": "current-player-avatar-expression",
              "seat": 2
            }
          },
          {
            "id": "seat2.ring",
            "piece": "host.ring.large.png",
            "x": 488.5,
            "y": 334,
            "w": 382,
            "tint": "none"
          },
          {
            "id": "seat2.pill",
            "piece": "pill.large.png",
            "x": 488.5,
            "y": 714,
            "w": 382,
            "tint": "cyan"
          }
        ],
        "texts": [
          {
            "id": "seat2.name",
            "text": "Bob",
            "x": 555.5,
            "y": 760,
            "w": 148,
            "cap": 28,
            "align": "center",
            "role": "name",
            "maxW": 148,
            "font": "Nunito",
            "weight": 800,
            "color": "#ffffff",
            "fit": "ellipsis",
            "maxChars": 8,
            "binding": {
              "kind": "player-name",
              "seat": 2,
              "selfLabel": "YOU",
              "fallback": "Player",
              "maxGraphemesIncludingEllipsis": 8
            }
          },
          {
            "id": "seat2.status",
            "text": "OFFLINE",
            "x": 719.5,
            "y": 764,
            "w": 84,
            "cap": 20,
            "align": "center",
            "role": "status",
            "maxW": 84,
            "font": "Barlow Condensed",
            "weight": 700,
            "color": "#a9bbea"
          }
        ],
        "removeIds": [
          "seat2.avatar",
          "seat2.status"
        ]
      }
    }
  },
  "states": {
    "host_waiting": {
      "textOverrides": {
        "cta.label": {
          "text": "START DATE"
        }
      },
      "elementOverrides": {
        "cta.plate": {
          "disabled": true,
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "disabledHits": [
        "cta"
      ]
    },
    "host_ready": {
      "textOverrides": {
        "cta.label": {
          "text": "START DATE"
        }
      },
      "elementOverrides": {
        "cta.plate": {
          "disabled": false,
          "brightness": 1,
          "opacity": 1
        }
      },
      "enabledHits": [
        "cta"
      ]
    },
    "guest_joined": {
      "textOverrides": {
        "cta.label": {
          "text": "I'M READY"
        },
        "edit.label": {
          "text": "LEAVE TABLE",
          "x": 567.5,
          "y": 1513,
          "w": 244,
          "maxW": 244,
          "cap": 24
        }
      },
      "hideIds": [
        "edit.icon"
      ],
      "elementOverrides": {
        "cta.plate": {
          "disabled": false,
          "brightness": 1,
          "opacity": 1
        }
      },
      "actions": {
        "edit": "leave-table",
        "cta": "set-ready"
      },
      "enabledHits": [
        "cta"
      ]
    },
    "guest_ready": {
      "textOverrides": {
        "cta.label": {
          "text": "READY"
        },
        "edit.label": {
          "text": "LEAVE TABLE",
          "x": 567.5,
          "y": 1513,
          "w": 244,
          "maxW": 244,
          "cap": 24
        }
      },
      "hideIds": [
        "edit.icon"
      ],
      "elementOverrides": {
        "cta.plate": {
          "disabled": true,
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "disabledHits": [
        "cta"
      ],
      "actions": {
        "edit": "leave-table"
      }
    },
    "expired": {
      "textOverrides": {
        "cta.label": {
          "text": "INVITE EXPIRED"
        },
        "timer": {
          "text": "Invite expired"
        }
      },
      "elementOverrides": {
        "cta.plate": {
          "disabled": true,
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "disabledHits": [
        "cta"
      ],
      "note": "Keep the same boxes. Empty seats still read Open Slot; no WAITING/CLOSED extra line. Other action availability follows existing application rules."
    },
    "start_pending": {
      "textOverrides": {
        "cta.label": {
          "text": "STARTING…"
        }
      },
      "elementOverrides": {
        "cta.plate": {
          "disabled": true,
          "brightness": 0.58,
          "opacity": 0.95
        }
      },
      "disabledHits": [
        "cta",
        "edit"
      ]
    },
    "action_error": {
      "textOverrides": {
        "timer": {
          "text": "Action failed. Try again.",
          "color": "#ffd84a"
        }
      },
      "note": "Existing application error feedback takes the timer lane temporarily; does not add another row or change geometry. Existing payment/auth dialogs remain outside this lobby layout."
    },
    "copy_success": {
      "textOverrides": {
        "copy.label": {
          "text": "COPIED",
          "x": 684.5,
          "y": 999.583,
          "w": 146,
          "maxW": 146,
          "cap": 22
        }
      },
      "hideIds": [
        "copy.icon"
      ],
      "note": "Returns to COPY after the existing feedback interval; button box unchanged."
    }
  },
  "grid": {
    "columns": [
      261.5,
      679.5
    ],
    "rows": {
      "seatCenter": 541,
      "pill": 714,
      "code": 896,
      "howto": 1142,
      "cta": 1286,
      "actions": 1468,
      "footer": 1606
    }
  },
  "margins": {
    "stageCenterX": 470.5,
    "primarySurface": {
      "left": 48.5,
      "right": 48.5,
      "width": 844
    },
    "wideText": {
      "left": 106.5,
      "right": 106.5,
      "width": 728
    },
    "sectionGap": 24,
    "actionColumnGap": 32,
    "actionWidth": 406,
    "howtoWidth": 680,
    "howtoInset": 82,
    "seatWidth": 382,
    "seatColumnGap": 36,
    "seatTextInset": 79,
    "statusInlineGap": 16,
    "measuredVerticalGaps": [
      {
        "from": "codebox.plate",
        "to": "howto.row",
        "fromBottom": 1118,
        "toTop": 1142,
        "gap": 24
      },
      {
        "from": "howto.row",
        "to": "cta.plate",
        "fromBottom": 1262.567,
        "toTop": 1286,
        "gap": 23.433
      },
      {
        "from": "cta.plate",
        "to": "invite.button",
        "fromBottom": 1444.493,
        "toTop": 1468,
        "gap": 23.507
      },
      {
        "from": "invite.button",
        "to": "timer",
        "fromBottom": 1582,
        "toTop": 1606,
        "gap": 24
      }
    ],
    "codeMainToCopyCenter": {
      "codeInkCenterY": 1008,
      "copyBoxCenterY": 1010.583,
      "difference": 2.583
    },
    "componentInsets": {
      "widePanelText": 58,
      "seatName": 79,
      "openSeatName": 79,
      "actionLabelOnly": {
        "left": 81,
        "right": 81
      },
      "actionWithIcon": {
        "iconLeft": 57,
        "iconWidth": 60,
        "iconToLabelGap": 45.5,
        "labelWidth": 154,
        "right": 89.5
      },
      "howto": {
        "titleBoxLeft": 142,
        "titleBoxWidth": 340,
        "titleBoxToChevronGap": 122,
        "chevronWidth": 24,
        "right": 52
      },
      "copy": {
        "iconLeft": 26,
        "iconWidth": 42,
        "iconToLabelGap": 27,
        "labelWidth": 88,
        "right": 39
      },
      "code": {
        "textColumnLeft": 139.5,
        "textColumnWidth": 432,
        "textColumnToCopyGap": 75
      }
    },
    "seatVertical": {
      "ringCenterY": 541,
      "hostRingBoxBottom": 700,
      "hostRingToPill": 14,
      "openRingBoxBottom": 698.526,
      "openRingToPill": 15.474,
      "pillBottom": 838,
      "pillToCode": 58
    }
  },
  "tintPolicy": {
    "cyan": "Only pieces tagged cyan receive the room filter",
    "none": "Gold rings, crowns, CTA, white icons, heart, stickers, avatars, logo, header controls and all text stay untinted"
  },
  "themes": {
    "flirt": {
      "filter": "hue-rotate(150deg)"
    },
    "meet": {
      "filter": "none"
    },
    "friends": {
      "filter": "hue-rotate(200deg) saturate(1.2)"
    },
    "date": {
      "filter": "none"
    }
  },
  "removedElements": [
    "howto.icon",
    "howto.body",
    "leave.icon"
  ],
  "examples": [
    {
      "id": "date",
      "theme": "date",
      "state": "host_waiting",
      "seats": [
        "host",
        "open"
      ]
    }
  ],
  "stateResolution": "Start from the base layout for each state. Apply selected seatVariants, then one primary state and any orthogonal feedback state. Never accumulate stale overrides. removeIds removes optional seat layers absent from the new variant.",
  "interactionAppearance": {
    "disabledSecondary": {
      "opacity": 0.45,
      "scope": "button + icon + label of the disabled hit target",
      "newAsset": false
    },
    "disabledCTA": {
      "brightness": 0.58,
      "opacity": 0.95,
      "labelColor": "#17120a",
      "newAsset": false
    },
    "pending": "Same boxes and the state label; disable only while existing application action is pending",
    "hoverAndPressed": "Use existing button feedback; no new shape or geometry"
  },
  "sharedStates": {
    "soundOff": {
      "elementOverrides": {
        "sound.icon": {
          "piece": "apps/client/public/art/ui-head/icon-sound-off@2x.png"
        }
      }
    },
    "nameMissing": {
      "replacement": "Player"
    },
    "nameTooLong": {
      "maxGraphemesIncludingEllipsis": 8,
      "fit": "ellipsis at fixed cap and maxW; never use a smaller name font"
    },
    "empty": {
      "seatVariant": "open",
      "name": "Open Slot",
      "statusVisible": false
    }
  },
  "layerOrder": [
    "background",
    "stickers",
    "avatars",
    "rings",
    "crowns",
    "plates",
    "icons",
    "texts",
    "logo-and-header"
  ],
  "sources": {
    "art/src/lobby-backgrounds-2026-09-22/date.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/date.png",
      "w": 941,
      "h": 1672,
      "pixelW": 941,
      "pixelH": 1672
    },
    "apps/client/public/art/room-logos/lobby-date.png": {
      "path": "apps/client/public/art/room-logos/lobby-date.png",
      "w": 880,
      "h": 521,
      "pixelW": 880,
      "pixelH": 521
    },
    "apps/client/public/art/ui-head/bg@2x.png": {
      "path": "apps/client/public/art/ui-head/bg@2x.png",
      "w": 276,
      "h": 276,
      "pixelW": 276,
      "pixelH": 276
    },
    "apps/client/public/art/ui-head/icon-back@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-back@2x.png",
      "w": 276,
      "h": 276,
      "pixelW": 276,
      "pixelH": 276
    },
    "apps/client/public/art/ui-head/icon-sound-on@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-on@2x.png",
      "w": 276,
      "h": 276,
      "pixelW": 276,
      "pixelH": 276
    },
    "sticker.ul.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ul.png",
      "w": 164,
      "h": 154,
      "pixelW": 328,
      "pixelH": 308
    },
    "sticker.ur.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.ur.png",
      "w": 198,
      "h": 154,
      "pixelW": 396,
      "pixelH": 308
    },
    "sticker.l.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.l.png",
      "w": 116,
      "h": 130,
      "pixelW": 232,
      "pixelH": 260
    },
    "sticker.r.png": {
      "path": "art/src/lobby-elements-2026-09-22/sticker.r.png",
      "w": 118,
      "h": 140,
      "pixelW": 236,
      "pixelH": 280
    },
    "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/neutral.webp",
      "w": 256,
      "h": 256,
      "pixelW": 256,
      "pixelH": 256
    },
    "host.ring.large.png": {
      "path": "art/src/lobby-elements-2026-09-22/host.ring.large.png",
      "w": 382,
      "h": 366,
      "pixelW": 764,
      "pixelH": 732
    },
    "pill.large.png": {
      "path": "art/src/lobby-elements-2026-09-22/pill.large.png",
      "w": 382,
      "h": 124,
      "pixelW": 764,
      "pixelH": 248
    },
    "open.ring.large.png": {
      "path": "art/src/lobby-elements-2026-09-22/open.ring.large.png",
      "w": 388,
      "h": 320,
      "pixelW": 776,
      "pixelH": 640
    },
    "heart.png": {
      "path": "art/src/lobby-elements-2026-09-22/heart.png",
      "w": 48,
      "h": 102,
      "pixelW": 96,
      "pixelH": 204
    },
    "gather.plate.png": {
      "path": "art/src/lobby-elements-2026-09-22/gather.plate.png",
      "w": 844,
      "h": 222,
      "pixelW": 1688,
      "pixelH": 444
    },
    "copy.button.png": {
      "path": "art/src/lobby-elements-2026-09-22/copy.button.png",
      "w": 216,
      "h": 114,
      "pixelW": 432,
      "pixelH": 228
    },
    "icon.link.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.link.png",
      "w": 60,
      "h": 60,
      "pixelW": 120,
      "pixelH": 120
    },
    "cta.plate.png": {
      "path": "art/src/lobby-elements-2026-09-22/cta.plate.png",
      "w": 868,
      "h": 163,
      "pixelW": 1736,
      "pixelH": 326
    },
    "howto.row.png": {
      "path": "art/src/lobby-elements-2026-09-22/howto.row.png",
      "w": 846,
      "h": 150,
      "pixelW": 1692,
      "pixelH": 300
    },
    "icon.chevron.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.chevron.png",
      "w": 30,
      "h": 40,
      "pixelW": 60,
      "pixelH": 80
    },
    "small.button.png": {
      "path": "art/src/lobby-elements-2026-09-22/small.button.png",
      "w": 406,
      "h": 114,
      "pixelW": 812,
      "pixelH": 228
    },
    "icon.people.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.people.png",
      "w": 70,
      "h": 70,
      "pixelW": 140,
      "pixelH": 140
    },
    "icon.pencil.png": {
      "path": "art/src/lobby-elements-2026-09-22/icon.pencil.png",
      "w": 70,
      "h": 70,
      "pixelW": 140,
      "pixelH": 140
    },
    "seat.ring.png": {
      "path": "art/src/lobby-elements-2026-09-22/seat.ring.png",
      "w": 260,
      "h": 220,
      "pixelW": 520,
      "pixelH": 440
    },
    "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp": {
      "path": "apps/client/public/avatars/cast/snw-cast-0002/neutral.webp",
      "w": 256,
      "h": 256,
      "pixelW": 256,
      "pixelH": 256
    },
    "apps/client/public/art/room-logos/lobby-meet.png": {
      "path": "apps/client/public/art/room-logos/lobby-meet.png",
      "w": 880,
      "h": 506,
      "pixelW": 880,
      "pixelH": 506
    },
    "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/reference-meet-background.png",
      "w": 941,
      "h": 1672,
      "pixelW": 941,
      "pixelH": 1672
    },
    "apps/client/public/art/room-logos/lobby-flirt.png": {
      "path": "apps/client/public/art/room-logos/lobby-flirt.png",
      "w": 880,
      "h": 508,
      "pixelW": 880,
      "pixelH": 508
    },
    "art/src/lobby-backgrounds-2026-09-22/flirt.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/flirt.png",
      "w": 941,
      "h": 1672,
      "pixelW": 941,
      "pixelH": 1672
    },
    "apps/client/public/art/room-logos/lobby-friends.png": {
      "path": "apps/client/public/art/room-logos/lobby-friends.png",
      "w": 880,
      "h": 500,
      "pixelW": 880,
      "pixelH": 500
    },
    "art/src/lobby-backgrounds-2026-09-22/friends.png": {
      "path": "art/src/lobby-backgrounds-2026-09-22/friends.png",
      "w": 941,
      "h": 1672,
      "pixelW": 941,
      "pixelH": 1672
    },
    "apps/client/public/art/ui-head/icon-sound-off@2x.png": {
      "path": "apps/client/public/art/ui-head/icon-sound-off@2x.png",
      "w": 276,
      "h": 276,
      "pixelW": 276,
      "pixelH": 276
    }
  },
  "sizingExamples": {
    "background": {
      "derivedHeight": 1672,
      "rule": "width * source.h / source.w"
    },
    "logo": {
      "derivedHeight": 260.5,
      "rule": "width * source.h / source.w"
    },
    "back.button": {
      "derivedHeight": 120,
      "rule": "width * source.h / source.w"
    },
    "back.icon": {
      "derivedHeight": 120,
      "rule": "width * source.h / source.w"
    },
    "sound.button": {
      "derivedHeight": 120,
      "rule": "width * source.h / source.w"
    },
    "sound.icon": {
      "derivedHeight": 120,
      "rule": "width * source.h / source.w"
    },
    "sticker.ul": {
      "derivedHeight": 154,
      "rule": "width * source.h / source.w"
    },
    "sticker.ur": {
      "derivedHeight": 154,
      "rule": "width * source.h / source.w"
    },
    "sticker.l": {
      "derivedHeight": 130,
      "rule": "width * source.h / source.w"
    },
    "sticker.r": {
      "derivedHeight": 140,
      "rule": "width * source.h / source.w"
    },
    "seat1.ring": {
      "derivedHeight": 366,
      "rule": "width * source.h / source.w"
    },
    "seat1.pill": {
      "derivedHeight": 124,
      "rule": "width * source.h / source.w"
    },
    "seat2.ring": {
      "derivedHeight": 315.052,
      "rule": "width * source.h / source.w"
    },
    "seat2.pill": {
      "derivedHeight": 124,
      "rule": "width * source.h / source.w"
    },
    "heart": {
      "derivedHeight": 102,
      "rule": "width * source.h / source.w"
    },
    "codebox.plate": {
      "derivedHeight": 222,
      "rule": "width * source.h / source.w"
    },
    "copy.button": {
      "derivedHeight": 117.167,
      "rule": "width * source.h / source.w"
    },
    "copy.icon": {
      "derivedHeight": 42,
      "rule": "width * source.h / source.w"
    },
    "cta.plate": {
      "derivedHeight": 158.493,
      "rule": "width * source.h / source.w"
    },
    "howto.row": {
      "derivedHeight": 120.567,
      "rule": "width * source.h / source.w"
    },
    "howto.chevron": {
      "derivedHeight": 32,
      "rule": "width * source.h / source.w"
    },
    "invite.button": {
      "derivedHeight": 114,
      "rule": "width * source.h / source.w"
    },
    "invite.icon": {
      "derivedHeight": 60,
      "rule": "width * source.h / source.w"
    },
    "edit.button": {
      "derivedHeight": 114,
      "rule": "width * source.h / source.w"
    },
    "edit.icon": {
      "derivedHeight": 60,
      "rule": "width * source.h / source.w"
    }
  },
  "verification": {
    "allImageHeightsDerived": true,
    "allSourceFilesExist": true,
    "allArtworkInsideStage": true,
    "onlyCyanAllowlistTinted": true,
    "fixedHeaderAndStickersVerified": true,
    "noTextInkOverlapsInDeliveredPreviews": true,
    "minTouchCssAt360": 44.378,
    "allMeasuredPrimaryTextAtLeast16Css": false,
    "allMeasuredSecondaryTextAtLeast14Css": false,
    "previewMethod": "Sharp raster composition at 2x, then downsample to 941x1672; FreeType with project fonts and measured H cap height",
    "runtimeBrowserTest": "not run; no application code changed",
    "previews": [
      {
        "file": "preview-layout-date.png",
        "state": "host_waiting",
        "theme": "date",
        "width": 941,
        "height": 1672,
        "sha256": "be496cd2fc210681365a6142841bf322c4cea902717ce060edd5bec08630e1de",
        "textInkBounds": [
          {
            "id": "code.heading",
            "text": "YOUR ROOM CODE",
            "requestedText": "YOUR ROOM CODE",
            "x": 315.25,
            "y": 932,
            "w": 310.5,
            "h": 22,
            "cap": 21,
            "actualCap": 21.5,
            "fontSize": 29.5,
            "cssFontAt360": 11.28586609989373,
            "role": "heading",
            "maxW": 480
          },
          {
            "id": "code.value",
            "text": "89SVJJ",
            "requestedText": "89SVJJ",
            "x": 245.75,
            "y": 984,
            "w": 219.5,
            "h": 49,
            "cap": 48,
            "actualCap": 48,
            "fontSize": 67,
            "cssFontAt360": 25.632306057385758,
            "role": "value",
            "maxW": 432
          },
          {
            "id": "code.url",
            "text": "play.saynoway.com/r/89SVJJ",
            "requestedText": "play.saynoway.com/r/89SVJJ",
            "x": 176,
            "y": 1054,
            "w": 359,
            "h": 26.5,
            "cap": 20,
            "actualCap": 20,
            "fontSize": 28,
            "cssFontAt360": 10.712008501594049,
            "role": "sub",
            "maxW": 432
          },
          {
            "id": "copy.label",
            "text": "COPY",
            "requestedText": "COPY",
            "x": 743.75,
            "y": 999.583,
            "w": 83.5,
            "h": 23,
            "cap": 22,
            "actualCap": 22.5,
            "fontSize": 31,
            "cssFontAt360": 11.859723698193411,
            "role": "button",
            "maxW": 88
          },
          {
            "id": "cta.label",
            "text": "START DATE",
            "requestedText": "START DATE",
            "x": 311.75,
            "y": 1345.747,
            "w": 317.5,
            "h": 42,
            "cap": 40,
            "actualCap": 40,
            "fontSize": 53.5,
            "cssFontAt360": 20.46758767268863,
            "role": "cta",
            "maxW": 478
          },
          {
            "id": "howto.title",
            "text": "HOW TO PLAY",
            "requestedText": "HOW TO PLAY",
            "x": 311,
            "y": 1189.284,
            "w": 263,
            "h": 27,
            "cap": 26,
            "actualCap": 26.5,
            "fontSize": 36.5,
            "cssFontAt360": 13.963868225292241,
            "role": "howto",
            "maxW": 340
          },
          {
            "id": "invite.label",
            "text": "INVITE",
            "requestedText": "INVITE",
            "x": 234.25,
            "y": 1513,
            "w": 107.5,
            "h": 24.5,
            "cap": 24,
            "actualCap": 24,
            "fontSize": 33.5,
            "cssFontAt360": 12.816153028692879,
            "role": "button",
            "maxW": 154
          },
          {
            "id": "edit.label",
            "text": "EDIT",
            "requestedText": "EDIT",
            "x": 688,
            "y": 1513,
            "w": 76,
            "h": 24.5,
            "cap": 24,
            "actualCap": 24,
            "fontSize": 33.5,
            "cssFontAt360": 12.816153028692879,
            "role": "button",
            "maxW": 154
          },
          {
            "id": "timer",
            "text": "Invites open for 14:53",
            "requestedText": "Invites open for 14:53",
            "x": 280,
            "y": 1606,
            "w": 381,
            "h": 35.5,
            "cap": 28,
            "actualCap": 28,
            "fontSize": 39,
            "cssFontAt360": 14.920297555791711,
            "role": "footer",
            "maxW": 600
          },
          {
            "id": "seat1.name",
            "text": "YOU",
            "requestedText": "YOU",
            "x": 184.75,
            "y": 760,
            "w": 81.5,
            "h": 28.5,
            "cap": 28,
            "actualCap": 28,
            "fontSize": 39,
            "cssFontAt360": 14.920297555791711,
            "role": "name",
            "maxW": 176
          },
          {
            "id": "seat1.status",
            "text": "HOST",
            "requestedText": "HOST",
            "x": 331.75,
            "y": 764,
            "w": 51.5,
            "h": 20,
            "cap": 20,
            "actualCap": 20,
            "fontSize": 28.5,
            "cssFontAt360": 10.903294367693942,
            "role": "status",
            "maxW": 56
          },
          {
            "id": "seat2.name",
            "text": "Open Slot",
            "requestedText": "Open Slot",
            "x": 586.5,
            "y": 758.5,
            "w": 186,
            "h": 35.5,
            "cap": 28,
            "actualCap": 28,
            "fontSize": 39,
            "cssFontAt360": 14.920297555791711,
            "role": "name",
            "maxW": 224
          }
        ]
      }
    ],
    "allElementDefinitionsUnchanged": true,
    "allElementStateOverridesUnchanged": true,
    "allTouchGeometryUnchanged": true,
    "onlyTextGeometryChanged": true,
    "minPrimaryFontCssAt360": 11.86,
    "minSecondaryFontCssAt360": 10.712,
    "textSizingAuthority": "Marko 22.9.2026 typography correction: reduce lettering within fixed artwork. This explicitly requested size correction overrides the earlier font floors for these drafts; see codex-typography-2026-09-22.md.",
    "allTextFitsWithoutAutoShrink": true
  }
}
